import { ClientBrowser } from "app/shared/models/clientBrowser.model";

export function getBrowserVersion(userAgent : any) : ClientBrowser{
    const clientBrowser = new ClientBrowser() ;
    if(userAgent.includes("Opera")){
        clientBrowser.browser = "Opera" ;
    }
    else if(userAgent.includes("Microsoft Internet Explorer")){
        clientBrowser.browser = "Microsoft Internet Explorer" ;
    }
    else if(userAgent.includes("Chrome")){
        clientBrowser.browser = "Chrome" ;
    }
    else if(userAgent.includes("Safari")){
        clientBrowser.browser = "Safari" ;
    }
    else if(userAgent.includes("Netscape")){
        clientBrowser.browser = "Netscape" ;
    }
    else if(userAgent.includes("Firefox")){
        clientBrowser.browser = "Firefox" ;
    }
    else if(userAgent.includes("Mozilla")){
        clientBrowser.browser = "Mozilla"
    }
    else{
        clientBrowser.browser = "" ;
    }
    clientBrowser.browserVersion = userAgent ;

    return clientBrowser ;
}